import { COMMON_HEADERS } from "./restApi";

import type { RequestHeaders } from "./restApi";

/**
 * Per-request headers merged by axios into the request config.
 * Returns undefined when there is nothing to merge (axios keeps default/common headers only).
 */
export function buildAxiosConfigWithHeaders(headers?: RequestHeaders): { headers: RequestHeaders } | undefined {
    if (headers === undefined || Object.keys(headers).length === 0) {
        return undefined;
    }

    return { headers: { ...headers } };
}

/**
 * Axios config for GET/DELETE (query params + optional per-request headers).
 */
export function buildAxiosQueryConfigWithHeaders(
    params?: unknown,
    headers?: RequestHeaders
): { params?: unknown; headers?: RequestHeaders } | undefined {
    const headersConfig = buildAxiosConfigWithHeaders(headers);
    if (params === undefined && headersConfig === undefined) {
        return undefined;
    }

    const config: { params?: unknown; headers?: RequestHeaders } = {};
    if (params !== undefined) {
        config.params = params;
    }

    if (headersConfig !== undefined) {
        config.headers = headersConfig.headers;
    }

    return config;
}

/**
 * Headers for fetch() JSON POST (common + optional + JSON + Authorization).
 */
export function buildHeadersForFetchConfig(authorization: string, headers?: RequestHeaders): RequestHeaders {
    return Object.assign({}, COMMON_HEADERS, headers || {}, {
        "Content-Type": "application/json",
        Authorization: authorization,
    });
}
